RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const PostsWithHashtagModal = RivalIQ.apps.Discovery.views.PostsModal.extend({

        onBeforeRenderLoaded: function () {
            const me = this;

            const Widget = Marionette.Dashboard.widgets.get(RivalIQ.enums.widgetTypes.INSIGHTS_MEDIA);
            const objectType = (me.getProp('objectType') === RivalIQ.enums.insightsObjectType.post) ? RivalIQ.enums.insightsObjectType.post : RivalIQ.enums.insightsObjectType.story;

            const postMetrics = App.utils.getDefaultPostColumnsForPostsModal(me.dashboardModel);

            const widget = new Widget(me.dashboardModel, {
                props: _.extend({}, me.dashboardModel.attributes, {
                    post_metrics: postMetrics,
                    story_metrics: [
                        'order_details',
                        'reach',
                        'impressions'
                    ],
                    columnLimit: null,
                    dimensions: ['timeAnalysisMode', objectType, 'channel', 'companyId'],
                    layout: 'list',
                    orderBy: 4,
                    sortTable: false,
                    trailingBar: false,
                    // fake value to make widget render in details mode
                    widgetId: true,
                    // No post details modal
                    noClickThrough: true,
                    analysisProperty: undefined,
                    modalWidget: true
                })
            });

            me.posts.showWidget(widget, null, {
                forceLoadingView: true
            });
        },

        loadData: function () {
            const me = this;

            // NOTE we are just returning totals here, so we don't want to even
            // think about ordering (which can cause errors when misconfigured,
            // see #22607)
            const props = _.omit(me.getProps(), ['orderBy']);

            const metricAttrs = {
                dimensions: ['timeAnalysisMode', 'channel', 'companyId', props.analysisProperty],
                property: 'count',
                channel: props.channel
            };

            const definition = App.utils.createInsightsMetric(props.objectType, metricAttrs);

            const metric = new RivalIQ.models.MetricDefinition(RivalIQ.metric.build(props, definition, {
                clobberDimensions: true
            }));

            return metric.fetch()
                .then(function (result) {
                    me.totalNumPosts = result.getValue({
                        format: false
                    });
                    me.numPostsShownMetric = Math.min(props.limit, me.totalNumPosts);
                });
        },

        serializeData: function () {
            const me = this;

            const channelName = RivalIQ.data.channels.get(RivalIQ.enums.sourceDetails[me.getProp('source')].channel).get('name');

            let postWord = `${_.upperFirst(RivalIQ.data.channels.get(me.getProp('channel')).get('postName'))}s`;
            switch (me.getProp('objectType')) {
                case RivalIQ.enums.insightsObjectType.story:
                    postWord = 'Stories';
                    break;
                case RivalIQ.enums.insightsObjectType.storyDay:
                    postWord = 'Story Days';
                    break;
                default:
                    break;
            }

            return {
                title: `${channelName} ${postWord} using #${me.getProp('hashtag')}`,
                totalNumPosts: me.totalNumPosts,
                numPostsShownMetric: me.numPostsShownMetric
            };
        }
    });

    PostsWithHashtagModal.show = function (curation, props) {
        // NOTE we want to use a consistent limit (other post modals, like the
        // one in Social Posts, request 100 posts)
        props.limit = 100;

        const dashboardModel = new RivalIQ.apps.Dashboard.models.Curation(null, props);
        // NOTE see #20498
        dashboardModel.presence = curation.getCuration().presence;
        RivalIQ.execute('show:modal', new PostsWithHashtagModal({
            dashboardModel: dashboardModel
        }));

        RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ViewedInsightsPostsModal, {
            channel: props.channel,
            objectType: props.objectType
        });
    };

    const getSearchTerm = function (oldSearchTerms, newSearchTerm) {
        let searchTerm = oldSearchTerms || '';

        const terms = searchTerm.split(/\s+/);

        const newTerm = (newSearchTerm || '').toLowerCase();

        const exists = Boolean(_.find(terms, function (term) {
            return term.toLowerCase() === newTerm;
        }));

        if (!exists) {
            searchTerm = [searchTerm, newSearchTerm]
                .map(_.trim)
                .join(' ');
        }

        return _.trim(searchTerm);
    };

    const HashtagCell = App.DimensionCell = RivalIQ.apps.SocialPosts.views.HashtagNameCell.extend({
        tagName: 'td',
        className: 'metric-table-cell',
        template: '#insightsHashtagsCellTemplate',

        getParams: function (tableModel, data) {
            const analysisProperty = tableModel.dashboardModel.getProp('analysisProperty');
            const params = _.pick(tableModel.getProps(), App.utils.validCurationOptions);
            const dimensionValue = RivalIQ.metric.format.formatDimension({
                property: 'name',
                dimensions: [analysisProperty]
            }, analysisProperty, _.last(data));
            params.searchTerm = getSearchTerm(params.searchTerm, dimensionValue);
            return params;
        },

        templateHelpers: function () {
            const me = this;
            const data = me.getOption('data');

            const child = {};
            // Set the relevant dimension to undefined to get the correct name
            child[me.model.get('dimension')] = undefined;
            const metric = me.model.build(child);

            const dashboardModel = me.getOption('table');
            const targetCuration = (dashboardModel.getProp('objectType') === RivalIQ.enums.insightsObjectType.post) ? RivalIQ.enums.curation.INSTAGRAM_INSIGHTS_POSTS : RivalIQ.enums.curation.INSTAGRAM_INSIGHTS_STORIES;

            return _.extend({
                name: metric.format(data[0]),
                executeSearchUrl: RivalIQ.apps.Dashboard.router.router.resolveCurationRoute(
                    targetCuration,
                    me.getParams(dashboardModel, data)
                ),
                postWord: RivalIQ.data.channels.get(dashboardModel.getProp('channel')).get('postName')
            }, RivalIQ.utils.emoji.getTemplateHelpers());
        }
    });

    const TableView = App.BaseDimensionTableView.extend({

        emptyViewOptions: function () {
            const me = this;
            const channel = me.getProp('channel');
            return {
                channel: channel
            };
        },

        emptyView: Marionette.ItemView.extend({
            template: '#insightsHashtagsWidgetNoResultsTemplate',
            serializeData: function () {
                const me = this;

                const postName = RivalIQ.data.channels.get(me.getOption('channel')).get('postName');
                return {
                    postName: `${postName}s`
                };
            }
        }),

        getFetchAttributes: function () {
            const me = this;

            const metrics = me.metricsCollection;

            let orderByIdx = Number(me.getProp('orderBy'));
            if (!_.isFinite(orderByIdx)) {
                orderByIdx = metrics.indexOf(metrics.findWhere({
                    property: me.getProp('orderBy')
                }));
            }

            me.sortColumns = me.metricsCollection.getColumnSortOrder(orderByIdx);

            return {
                hashtagLimit: Number(me.getProp('limit') || 0),
                hashtagSortOrder: Number(me.getProp('sortOrder') || 1),
                hashtagOrderBy: metrics.at(me.sortColumns[0]).get('property'),
                hashtagsMinPosts: Number(me.getProp('hashtagsMinPosts')),
                limit: undefined,
                sortOrder: undefined,
                orderBy: undefined
            };
        },

        onRowClick: function (data, e) {
            const me = this;

            e.preventDefault();

            const targetHashtag = data[0][0];
            const formattedTargetHashtag = RivalIQ.metric.format.formatDimension({
                property: 'name',
                dimensions: ['hashtag']
            }, 'hashtag', targetHashtag);

            PostsWithHashtagModal.show(me.dashboardModel.curation, _.extend(me.getProps(), {
                hashtag: targetHashtag,
                searchTerm: getSearchTerm(me.getProp('searchTerm'), formattedTargetHashtag)
            }));
        }
    });

    const HashtagsTable = RivalIQ.apps.Dashboard.widgets.TableWidget.extend({
        view: TableView,
        tableClassName: 'table-fix',

        processProps: function (props) {
            const me = this;

            props = _.defaults(props, {
                sortable: true,
                orderBy: 1,
                sortOrder: 1
            });

            App.utils.buildInsightsTableMetrics(me, {
                property: 'name',
                dimensions: [props.analysisProperty],
                sortable: false,
                cellView: _.constant(HashtagCell)
            }, props);

            return props;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.INSIGHTS_HASHTAGS_TABLE, HashtagsTable);

    // return an array of metric properties that are in the order metrics should be sorted
    const getHashtagInsightMetrics = function (source, objectType) {
        if (objectType === RivalIQ.enums.insightsObjectType.post) {
            switch (source) {
                case RivalIQ.enums.sources.INSTAGRAM_INSIGHTS:
                    return ['count', 'organic_engagement_rate_by_reach', 'organic_reach_per_post'];
                case RivalIQ.enums.sources.LINKEDIN:
                    return ['count', 'engagement_rate_by_impression'];
                case RivalIQ.enums.sources.FACEBOOK_INSIGHTS:
                    return ['count', 'engagement_rate_by_reach'];
                case RivalIQ.enums.sources.TWITTER_INSIGHTS:
                    return ['count', 'engagement_rate_by_impression'];
                default:
                    throw new Error(`Hashtag Insights Metrics - unknown source ${source}`);
            }
        } else {
            return ['count', 'reach_per_story'];
        }
    };

    const HashtagsUsageView = App.views.HashtagsUsageView = RivalIQ.views.LayoutView.mixin({
        template: '#insightsHashtagsWidgetViewTemplate',

        ui: {
            insightText: '.insights-text'
        },

        regions: {
            table: '.x-table'
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props,
            normalizeHeights: RivalIQ.apps.Dashboard.mixins.NormalizeHeights
        },

        dashboardModelEvents: {
            'change': 'reload'
        },

        loadData: function () {
            const me = this;
            const props = me.getProps();
            // export es doesn't like seeing these table properties when requesting hashtags data, so omit them here
            me.metric = new RivalIQ.models.MetricDefinition(_.omit(_.clone(me.dashboardModel.baseMetric), ['sortOrder', 'limit', 'orderBy']));

            const metrics = _.map(getHashtagInsightMetrics(props.source, props.objectType), function (property) {
                return me.metric.build({
                    dimensions: [props.analysisProperty],
                    property: property
                });
            });

            const collection = new RivalIQ.collections.MetricDefinitions(metrics);

            return collection.fetch()
                .then(function (metrics) {
                    const hashtagsByCount = metrics.at(0).getValue({
                        format: false
                    });
                    const otherHashtags = _.map(_.drop(metrics.models, 1), function (metric) {
                        return metric.getValue({
                            format: false
                        });
                    });

                    const hashtags = _.map(hashtagsByCount, function (hashtag) {
                        const hashtagName = hashtag[0];
                        const count = hashtag[1];
                        const otherMetrics = _.map(otherHashtags, function (hashtagMetrics) {
                            return _.last(_.find(hashtagMetrics, function (focusHashtag) {
                                return focusHashtag[0].toLowerCase() === hashtagName.toLowerCase();
                            }));
                        });
                        return [hashtagName, count].concat(otherMetrics);
                    });

                    const topMostUsed = _.take(_.orderBy(hashtags, _.range(1, hashtags.length), _.times(hashtags.length - 2, function () { return 'desc'; })), props.limit);

                    const maps = _.reduce(topMostUsed, function (memo, hashtag) {
                        const collected = {};
                        if (props.objectType === RivalIQ.enums.insightsObjectType.post) {
                            // index 2 is organic_engagement_rate_by_reach
                            collected.engagement = memo.engagement.concat([[hashtag[0], hashtag[2]]]);
                            collected.reach = memo.reach.concat([[hashtag[0], hashtag[3]]]);
                        } else if (props.objectType === RivalIQ.enums.insightsObjectType.story) {
                            collected.reach = memo.reach.concat([[hashtag[0], hashtag[2]]]);
                        }
                        return collected;
                    }, {
                        reach: [],
                        engagement: []
                    });

                    me.hashtagsEngTotal = maps.engagement;
                    me.hashtagsReach = maps.reach;
                });
        },

        getInsightText: function () {
            const me = this;

            const numShown = Math.min(me.getProp('limit'), me.hashtagsReach.length);
            const maxReachHashtag = _.maxBy(me.hashtagsReach, function (hashtag) {
                return hashtag[1];
            });
            const maxEngTotalHashtag = _.maxBy(me.hashtagsEngTotal, function (hashtag) {
                return hashtag[1];
            });

            let insight = `Of the ${numShown} most used hashtags, <strong>#`;
            if (me.getProp('objectType') === RivalIQ.enums.insightsObjectType.post) {
                const postWord = RivalIQ.data.channels.get(me.getProp('channel')).get('postName');

                const maxEngTotal = _.last(maxEngTotalHashtag);
                if (!maxEngTotal) {
                    return `Your hashtags didn't generate any engagement during this time period.`;
                }

                insight += `${maxEngTotalHashtag[0]}</strong> generated the highest `;
                if (me.getProp('source') === RivalIQ.enums.sources.INSTAGRAM_INSIGHTS) {
                    insight += 'organic engagement rate by reach';
                } else {
                    insight += 'engagement rate by impression';
                }

                if (maxReachHashtag && maxReachHashtag[0] === maxEngTotalHashtag[0]) {
                    return `${insight} as well as the most reach per ${postWord}.`;
                } else {
                    return `${insight}.`;
                }
            } else if (_.size(maxReachHashtag) && me.getProp('objectType') === RivalIQ.enums.insightsObjectType.story) {
                return `${insight + maxReachHashtag[0]}</strong> generates the most reach per frame.`;
            }
        },

        onBeforeRenderLoaded: function () {
            const me = this;
            me.showTable();
        },

        onRenderLoaded: function () {
            const me = this;
            const numHashtagsShown = Math.min(me.getProp('limit'), me.hashtagsReach.length);
            if ((me.getProp('limit') === -1) || (numHashtagsShown === 0)) {
                // we're probably in the details view
                me.ui.insightText.hide();
            }
        },

        showTable: function () {
            const me = this;

            const widget = me.dashboardModel.getWidget('hashtags-table');
            me.table.showWidget(widget, {
                className: `table-double-header ${me.dashboardModel.isExporting() ? 'x-table-container' : 'table-responsive'}`
            });
        },

        serializeData: function () {
            const me = this;
            return {
                insight: me.getInsightText()
            };
        }
    });

    const HashtagsUsage = RivalIQ.apps.Dashboard.models.Widget.mixin({
        view: HashtagsUsageView,
        title: RivalIQ.strings.insights_hashtags_widget_title,
        panelView: App.views.ManageColumnsPanel,
        detailPanelView: App.views.ManageColumnsPanel,
        getExportTitle: App.utils.insightsExportTitle,
        getExportSubtitle: App.utils.insightsExportSubtitle,
        getPptSubtitle: App.utils.insightsPptSubtitle,
        exportFormats: [
            RivalIQ.enums.exportFormat.PDF,
            RivalIQ.enums.exportFormat.PPT,
            RivalIQ.enums.exportFormat.PNG,
            RivalIQ.enums.exportFormat.CSV
        ],
        scheduledExportAdvancedSettingsEnabled: false,

        csvExportProps: function () {
            const me = this;
            const props = me.getProps();

            return {
                type: 'metric',
                isPrivateData: true,
                analysisProperty: props.analysisProperty,
                metric: _.defaults({
                    limit: -1,
                    startDate: me.baseMetric.timePeriod.mainPeriodStart,
                    endDate: me.baseMetric.timePeriod.mainPeriodEnd
                }, me.baseMetric)
            };
        },

        propsToSerializeForExport: [
            'hashtagsMinPosts'
        ].concat(App.utils.widgetExportProps),

        getPropsForSerialization: function (props) {
            return _.pick(props, 'post_metrics');
        },

        description: function () {
            const me = this;
            if (me.getProp('objectType') === RivalIQ.enums.insightsObjectType.post) {
                const postWord = RivalIQ.data.channels.get(me.getProp('channel')).get('postName');
                return RivalIQ.str('insights_posts_hashtags_description', postWord, postWord);
            } else if (me.getProp('objectType') === RivalIQ.enums.insightsObjectType.story) {
                // TODO: put mentions of row interactions back into the description when the time comes
                return RivalIQ.strings.instagram_insights_stories_hashtags_description;
            }
        },

        viewMorePath: function () {
            const me = this;

            return me.getPath({
                limit: -1,
                orderBy: me.getProp('orderBy'),
                sortOrder: me.getProp('sortOrder')
            });
        },

        filter: function () {
            const me = this;

            const objectType = me.getProp('objectType');
            const isPostObjectType = (objectType === RivalIQ.enums.insightsObjectType.post);

            return (isPostObjectType && RivalIQ.apps.Insights.utils.isLoadingInstagramPromotedPosts(me));
        },

        processProps: function (props) {
            const me = this;

            _.defaults(props, {
                limit: 8,
                analysisProperty: 'hashtag',
                omitTimeAnalysisModeDescription: true
            });

            const objectType = me.getProp('objectType');
            if (objectType === RivalIQ.enums.insightsObjectType.post) {
                // NOTE if we are in a summary view we want to limit the metrics
                // to three (plus the dimension column, hashtag, for four total)
                if (!me.isFocus()) {
                    props.columnLimit = 4;
                } else {
                    delete props.columnLimit;
                }

                if (props.source === RivalIQ.enums.sources.INSTAGRAM_INSIGHTS && _.isEmpty(props.post_metrics)) {
                    const hasPaidEngagement = App.utils.hasInstagramPaidEngagement(me);
                    if (hasPaidEngagement) {
                        props.post_metrics = [
                            'count',
                            'impressions',
                            'engagement_rate_by_impression'
                        ];
                    } else {
                        props.post_metrics = [
                            'count',
                            'organic_impressions',
                            'organic_engagement_rate_by_impression'
                        ];
                    }

                    if (_.isEmpty(me.configurationProps.post_metrics)) {
                        me.configurationProps.post_metrics = props.post_metrics;
                    }
                }
            }

            me.baseMetric = App.utils.createInsightsMetric(props.objectType, _.defaults({
                dimensions: ['timeAnalysisMode', 'channel', 'companyId']
            }, props));

            return props;
        },

        widgetDefinitions: function () {
            const me = this;

            const props = {
                showDescriptions: true
            };

            const objectType = me.getProp('objectType');
            if (objectType === RivalIQ.enums.insightsObjectType.post) {
                props.trailingBar = true;
            }

            const widgets = [{
                instanceId: 'hashtags-table',
                neverFilter: true,
                widgetId: RivalIQ.enums.widgetTypes.INSIGHTS_HASHTAGS_TABLE,
                baseMetric: me.baseMetric,
                props: props
            }];

            return widgets;
        },

        allowPageBreaks: App.utils.allowPageBreaksInFocus
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.INSIGHTS_HASHTAGS, HashtagsUsage);
});
